import {isEqual} from '@shared/helpers/lang'

import {GroupItem} from '@web/slices/card/slice'
import {OrderSheetSelectedCoupons} from '@web/slices/orderSheetCoupon/slice'

/**
 * 나의할인가 정보가 변경되었는지 여부
 */
export const getMyOptimalDiscountChanged = ({
    prev,
    curr,
}: {
    prev: {
        coupon?: OrderSheetSelectedCoupons
        group?: GroupItem
    }
    curr: {
        coupon?: OrderSheetSelectedCoupons
        group?: GroupItem
    }
}) => {
    const isGroupChanged = !(
        isEqual(prev.group?.card, curr.group?.card) &&
        isEqual(prev.group?.myOptimalDiscountPayAmount, curr.group?.myOptimalDiscountPayAmount)
    )
    const isCouponChanged = !isEqual(prev.coupon, curr.coupon)
    return {
        isGroupChanged,
        isCouponChanged,
        changed: isGroupChanged || isCouponChanged,
    }
}
